import {  
    getFirestore, 
    doc,
    deleteDoc
} from "firebase/firestore";
import bqGetProgramMemberListById from "./bqGetProgramMemberListById";
// import setProgramInfo from "./setProgramInfo";
const removeProgram = async function(id) {
    let db = getFirestore();
    let userList = await bqGetProgramMemberListById(id) || [];
    if( !userList.length ){
        // await Promise.all(
        //     userList.map(async (item) => {
        //         await setProgramInfo({ action: 'delete'}, id, item.uid);
        //     })
        // );
        const docRef = doc(db, "wellness_program", id);
        await deleteDoc(docRef);
    }
    
};

export default removeProgram;
